/** angular */
import { Injectable } from '@angular/core';
/** end angular */

/** rxjs */
import { Observable } from 'rxjs';
/** end rxjs */

/** services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** end services */

/** models */
import { DsFormsExportResponse } from '../models/ds-forms-export-response.class';
/** end models */

/** interfaces */
import { DsFormsExportResponseInterface } from '../interfaces/forms-export/ds-forms-export-response.interface';
import { HttpResponse } from '@angular/common/http';
import { BydGenerateParams } from '@sixense/byd-core-service';
import { Params } from '@angular/router';
/** end interfaces */

@Injectable({
  providedIn: 'root',
})
export class DsFormWordExportService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get directly the blob corresponding to the form template word export model.
   *
   * @param projectId Selected project id
   * @param formTemplateId Form template id
   * @param linear Whether to call the linear export
   * @returns Observable<HttpResponse<Blob>>
   */
  public downloadModel(projectId: number, formTemplateId: number, linear?: boolean): Observable<HttpResponse<Blob>> {
    if (linear) {
      this.path = `/v1/dslinear/projects/${projectId}/linearforms/${formTemplateId}/docxexport`;
    } else {
      this.path = `/v1/dsform/projects/${projectId}/forms/${formTemplateId}/docxexport`;
    }
    return this.get<HttpResponse<Blob>>({ responseType: 'blob', observe: 'response' });
  }

  /**
   * Start the word export of form instances, the word file(s) are received by mail.
   *
   * @param projectId Selected project id
   * @param instanceIds List of instance id
   * @param customTemplateId The word model id
   * @param queryParams filter queryParams
   * @returns Observable<DsFormsExportResponse>
   */
  public startFormWordExport(
    projectId: number,
    instanceIds: number[],
    customTemplateId: number,
    queryParams: Params
  ): Observable<DsFormsExportResponse> {
    const params = BydGenerateParams(queryParams);

    this.path = `/v1/dsform/projects/${projectId}/instances/docxexport`;
    return this.postModel<DsFormsExportResponse>({
      params,
      body: { instanceIds, customTemplateId, reportName: queryParams.reportName },
    });
  }

  /**
   * Create DsFormsExportResponse instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsFormsExportResponse` instance.
   */
  public createNewInstance(jsonObject: DsFormsExportResponseInterface) {
    return new DsFormsExportResponse(jsonObject);
  }
}
